import type { Locale } from '@backmarket/http-api'
import { setBrowserCookie } from '@backmarket/utils/cookies/setBrowserCookie'

import { COOKIE_LANGUAGE } from '../../constants'

export default function changeLanguage(locale: Locale) {
  setBrowserCookie(COOKIE_LANGUAGE, locale, { path: '/' })
  window.location.reload()
}
